import { render, staticRenderFns } from "./service-object.vue?vue&type=template&id=36637092&scoped=true&"
import script from "./service-object.vue?vue&type=script&lang=js&"
export * from "./service-object.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36637092",
  null
  
)

export default component.exports